/**
 * POST `admin/tariffs/clinic` — новая версия пакетов клиники
 * (ADMIN_BACKEND §5.2). Строгая валидация (возрастание границ и цены) —
 * на клиенте перед вызовом; BE проверяет повторно (422). Цены — в тыйынах;
 * ответ несёт affectedClients — скольких клиник коснётся смена.
 */

import {apiEnabled, http} from '@services/utils';

import {AFFECTED_ON_SAVE, applyClinicVersionMock} from '../mocks';
import type {SaveClinicInput, SaveClinicResult} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const saveClinicTariff = async (input: SaveClinicInput): Promise<SaveClinicResult> => {
  if (!apiEnabled) {
    await sleep(700);
    return {
      ok: true,
      version: applyClinicVersionMock(input),
      affectedClients: AFFECTED_ON_SAVE.clinic,
    };
  }

  const raw = await http<Record<string, unknown>>('admin/tariffs/clinic', {
    method: 'POST',
    body: {
      packages: input.packages.map((p) => ({
        name: p.name,
        upTo: p.upTo,
        priceTiyin: Math.round(p.price * 100),
      })),
      overPriceTiyin: Math.round(input.overPrice * 100),
    },
    skipCaseConversion: true,
  });
  return {
    ok: true,
    version: typeof raw.version === 'number' ? raw.version : 0,
    affectedClients: typeof raw.affectedClients === 'number' ? raw.affectedClients : null,
  };
};
